export const LanguagesActionTypes = {
  API_RESPONSE_SUCCESS: '@@languages/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@languages/API_RESPONSE_ERROR',

  GET_DICTIONARY: '@@languages/GET_DICTIONARY',
  ADD_DICTIONARY: '@@languages/ADD_DICTIONARY',
  UPDATE_DICTIONARY: '@@languages/UPDATE_DICTIONARY',

  RESET: '@@languages/RESET'
}
